import type { SVGProps } from "react";

export const GoogleSheets = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 314.7 428"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google Sheets</title>{" "}
    <path d="M206 108.7h108.7L206 0z" fill="#188038" />{" "}
    <path
      d="M206 108.7V0H24C10.7 0 0 10.7 0 24v380c0 13.3 10.7 24 24 24h266.7c13.3 0 24-10.7 24-24V108.7z"
      fill="#34a853"
    />{" "}
    <path
      d="M60 167.9V315h194.7V167.9zM145.3 291H84v-37.6h61.3zm0-61.5H84v-37.6h61.3zm85.4 61.5h-61.3v-37.6h61.3zm0-61.5h-61.3v-37.6h61.3z"
      fill="#fff"
    />
  </svg>
);

export default GoogleSheets;
